export * from 'server/models/BerthAssignmentDetailsResponse';


// WEBPACK FOOTER //
// ./data/models/BerthAssignmentDetailsResponse.ts